import { Checkbox, FormGroup, FormControlLabel } from '@mui/material';
import { FC } from 'react';
import { FilterField } from '../types';

type Props = FilterField & {
  filters: Record<string, any>;
  onChange: (value: any) => void;
};
export const CheckboxFilter: FC<Props> = ({ name, label, filters, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange((prev: any) => ({
      ...prev,
      [name]: event.target.checked,
    }));
  };

  return (
    <FormGroup>
      <FormControlLabel
        key={name}
        control={<Checkbox checked={!!filters[name]} onChange={handleChange} color="primary" />}
        label={label}
      />
    </FormGroup>
  );
};
